// frontend/src/hooks/useApi.js
import { useState, useEffect, useRef, useCallback } from 'react';

export function useApi(fetchFn, deps = []) {
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  // Keep a ref to the latest fetchFn so callers can pass inline arrow functions
  // without causing infinite re-render loops
  const fetchRef = useRef(fetchFn);
  useEffect(() => { fetchRef.current = fetchFn; });

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await fetchRef.current();
      setData(result);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, deps); // deps intentionally controls when load() re-creates — not fetchFn itself

  useEffect(() => { load(); }, [load]);

  return { data, loading, error, refetch: load };
}
